import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'features.thankYouPage.pageTitle',
    defaultMessage: 'Benvenuto',
    description: 'Title of the thank you page',
  },
  pageMessageHeader: {
    id: 'features.thankYouPage.pageMessageHeader',
    defaultMessage: 'Gentile {name},',
    description: 'Text before the name of the user',
  },
  pageMessageThankYouParagraph: {
    id: 'features.thankYouPage.pageMessageThankYouParagraph',
    defaultMessage:
      'Grazie per aver completato le fasi di onboarding relative alla registrazione della tua utenza.',
    description: 'Message of the thank you page',
  },
  pageMessageInviteParagraph: {
    id: 'features.thankYouPage.pageMessageInviteParagraph',
    defaultMessage:
      'Ti invitiamo a proseguire con la compilazione dei Questionari AML e MIFID: effettua il login al portale o all’app MyAzimut, utilizzando l’email verificata tramite OTP e la password scelta.',
    description: 'asdf',
  },
});
